import React from 'react'
import styled from 'styled-components'
import Navbar from '../Navbar/Navbar'

const Layout = ({ children }) => {
  const [rightNavbarMinified, setRightNavbarMinified] = React.useState(true)
  const [leftNavbarMinified, setLeftNavbarMinified] = React.useState(true)
  const [rightNavbarVisible, setRightNavbarVisible] = React.useState(true)
  const getMargin = () => {
    let margin = 0
    if (rightNavbarMinified) {
      margin = margin + 211
    } else margin = margin + 370
    return margin.toString() + 'px'
  }

  return (
    <Wrapper>
      <Navbar
        leftNavbarMinified={leftNavbarMinified}
        setLeftNavbarMinified={setLeftNavbarMinified}
        rightNavbarMinified={rightNavbarMinified}
        setRightNavbarMinified={setRightNavbarMinified}
        rightNavbarVisible={rightNavbarVisible}
      />
      <ChildWrapper marginLeft={rightNavbarVisible ? getMargin() : '0px'}>
        {React.cloneElement(children, {
          rightNavbarMinified,
          leftNavbarMinified,
          rightNavbarVisible,
          setRightNavbarVisible,
        })}
      </ChildWrapper>
    </Wrapper>
  )
}

export default Layout

const Wrapper = styled.div`
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #fbfbfb;
  /* overflow: hidden; */
  overflow-x: hidden;
  display: flex;
  flex-direction: row;
`

const ChildWrapper = styled.div`
  box-sizing: border-box;
  margin-left: ${({ marginLeft }) => marginLeft};

  max-width: 100%;
  width: 100%;
  /* padding: 2%; */
  /* background-color: #132546; */
  display: flex;
  flex-direction: row;
`
